import { useState, useEffect } from 'react';
import classnames from 'classnames';
import { TableRow, TableCell, Collapse } from '@mui/material';
import { withStyles } from '@mui/styles';
import APCell from './APCell';
import APTradeCell from './APTradeCell';
import { APTradesSeriesTable } from "./../APSeriesTable";
import { SeriesField } from './../../../core/types/Series';
import APSeriesTableStyles from './styles/APSeriesTable.style';
import usePreviousValue from '../../../core/utils/Hooks';

const StyledTableRow = withStyles((theme) => ({
    root: {
        backgroundColor: '#F5F5F5', // TODO - Get hex colour codes from constant style variables
        '&.isResponsive': {
            display: 'block',
            width: 'auto',
            padding: '1.25em',
            position: 'relative',
        }
    },
}))(TableRow);

const ExpandedTableRow = withStyles((theme) => ({
    root: {
        backgroundColor: '#F5F5F5'
    }
}))(TableRow);

const TradeTransaction = (column: any, breakPoint: any) => {
    let referralsSearchSeries = column.events;
    if (referralsSearchSeries) {
        return (
            <APTradesSeriesTable
                hideEvent
                pagination={10}
                series={referralsSearchSeries}
                breakPoint={breakPoint}
            />
        );
    }
}

function APTradeRows(props: any) {
    const {
        classes,
        responsiveClass,
        event,
        ignored,
        display,
        breakPoint,
        indexNumber,
        page
    } = props;
    const [open, setOpen] = useState(false);
    const prevPage = usePreviousValue(page);

    useEffect(() => {
        if (prevPage !== page) {
            open && setOpen(false);
        }
    }, [prevPage, page, open]);

    return (
        <>
            <StyledTableRow
                className={classnames(responsiveClass, open ? classes.tradeTableOpen : '',
                    (indexNumber % 2 !== 0) ? classes.evenTradeRow : '')}>

                {event.fields.map((column: SeriesField) => (
                    !ignored.includes(column.fieldName) &&
                    <TableCell
                        data-label={column.fieldLabel}
                        className={classnames(classes.tableCell, responsiveClass,
                            display[0].fields.length <= 3 ? classnames(classes.smallTableCell,
                                classes.smallSearchTableCell) : classes.smallSearchTableCell,
                            column.fieldName === 'Trades' ? classes.tradeButtonCell : '',
                            open ? classes.tradeTableOpen : '')}
                        key={`${event.event.eventLabel}-${column.fieldName}`}>

                        {/* TODO - Might not work for other languages */}
                        {
                            column.fieldName === 'Trades' ?
                                <APTradeCell
                                    SetOpen={(value) => { setOpen(value) }}
                                    field={column} responsiveClass={responsiveClass} /> :
                                <APCell field={column} />
                        }
                    </TableCell>
                ))}
            </StyledTableRow>
            <ExpandedTableRow
                className={classnames(responsiveClass, (indexNumber % 2 !== 0) ? classes.evenTradeRow : '')}>
                <TableCell className={classnames(classes.tradeTableCell, open ? 'isOpen' : '')} colSpan={12}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        {event.fields.map((column: SeriesField) => (
                            column.fieldArrayValue && TradeTransaction(column.fieldArrayValue, breakPoint)
                        ))}
                    </Collapse>
                </TableCell>
            </ExpandedTableRow>
        </>
    );
}

export default withStyles(APSeriesTableStyles)(APTradeRows);